import React, { useContext } from "react";
import { AppContext } from "../Index";
import "./FoodItem.css";
import config from "../../config/appConstants";
import Swal from "sweetalert2";
const { API_ROUTE, API_TOKEN } = config;
const FoodItem = ({ menuItem }) => {
  const {
    setCartItems,
    setAddCondimentsModal,
    cartItems,
    timeValid,
    setTimeValid,
  } = useContext(AppContext);

  const hasBadCondiments = (condiments, itemQty) => {
    if (itemQty === 0) return false;
    if (condiments) {
      const sumByGroupType = condiments.reduce((acc, condiment) => {
        const { condimentGroupTypeValue, quantity } = condiment;
        acc[condimentGroupTypeValue] =
          (acc[condimentGroupTypeValue] || 0) + quantity;
        return acc;
      }, {});
      const hasBadChoice = Object.values(sumByGroupType).some((choice) => {
        return choice > itemQty;
      });
      if (hasBadChoice) {
        Swal.fire({
          title: "Adjust Condiments",
          text: `Please reduce the condiments `,
          icon: "warning",
          confirmButtonColor: "#0f145b",
        });
        return true;
      }
    }
    return false;
  };
 const addItemToCart = () => {
  if (!timeValid.isServiveOpen) {
    setTimeValid((prevState) => ({
      ...prevState,
      isModalOpen: true,
    }));
    return;
  }

  setCartItems((prevItems) => {
    const existingItem = prevItems.find(
      (item) => item.itemCode === menuItem.itemCode,
    );

    // ===== ITEM ALREADY EXISTS =====
    if (existingItem) {
      const updatedItem = {
        ...existingItem,
        quantity: existingItem.quantity + 1,
      };

      // 🔥 OPEN CONDIMENT MODAL AFTER INCREMENT
      if (existingItem.condimentItems?.length) {
        setAddCondimentsModal({ ...updatedItem });
      }

      return prevItems.map((item) =>
        item.itemCode === menuItem.itemCode
          ? updatedItem
          : item,
      );
    }

    // ===== NEW ITEM =====
    const newItem = { ...menuItem, quantity: 1 };

    // 🔥 OPEN MODAL WHEN FIRST ADDED
    if (menuItem.condimentItems?.length) {
      setAddCondimentsModal({ ...newItem });
    }

    return [...prevItems, newItem];
  });
};
  const removeItemFromCart = () => {
    setCartItems((prevItems) => {
      return prevItems
        .map((item) => {
          if (item.itemCode === menuItem.itemCode) {
            if (item.condiments) {
              if (hasBadCondiments(item.condiments, item.quantity - 1)) {
                setAddCondimentsModal({
                  ...item,
                  quantity: item.quantity - 1,
                });
              }
            }
            if (item.quantity > 1) {
              // Decrease item quantity
              const updatedQuantity = item.quantity - 1;

              // Decrease condiments quantity to match the updated item quantity
              const updatedCondiments =
                item.condiments &&
                item.condiments.map((condiment) => ({
                  ...condiment,
                  quantity:
                    condiment.quantity === item.quantity
                      ? condiment.quantity
                      : condiment.quantity,
                }));
              return {
                ...item,
                quantity: updatedQuantity,
                condiments: updatedCondiments,
              };
            } else {
              // Remove the item if the quantity is 1
              return null;
            }
          }
          return item;
        })
        .filter(Boolean); // Remove any null items
    });
  };
  const isItemInCart = cartItems.find(
    (item) => item.itemCode === menuItem.itemCode,
  );
  // const isStockAvailable = menuItem.availableStock > 0;
  const isStockAvailable = true; // Assuming stock is always available for simplicity
  const stockLimitExceeded = menuItem.availableStock === isItemInCart?.quantity;
  return (
    // <div className="menu-card-container mt-1">
    //   <div className="d-flex justify-content-between align-items-center menu-card-section rounded p-0 card-bg-items">
    //     <div className="col-6 col-md-7">
    //       <div className="">
    //         <u className="text-decoration-none">
    //           <h4 className="d-flex justify-content-start p-0 mb-2 menu-item-name ">
    //             <span>{menuItem.name} </span>
    //           </h4>
    //           <span
    //             className="d-flex justify-content-start p-0 m-0 menu-item-description"
    //             dangerouslySetInnerHTML={{ __html: menuItem.description || "" }}
    //           />

    //         </u>

    //         {menuItem.imageUrl && (
    //           <div className=" mt-3 mt-md-0 col-12 col-sm-7 col-md-5 col-lg-8">
    //             <div className="img-container">
    //               <img
    //                 src={API_ROUTE + menuItem.imageUrl}
    //                 className="img-fluid menu-item-img"
    //                 alt={menuItem.name}
    //               />
    //             </div>
    //           </div>
    //         )}
    //       </div>
    //     </div>
    //     <div className="f">
    //       <div className="d-flex flex-column flex-md-row  gap-2 align-items-center justify-content-center">
    //         <div className="add-to-cart-section d-flex align-items-center">
    //           <div className="price w-100 mx-2 my-1">
    //             {`AED ${(Math.round(menuItem.price * 100) / 100).toFixed(2)}`}
    //           </div>
    //           {isItemInCart ? (
    //             <div className="d-flex px-2 justify-content-center align-items-center gap-2">
    //               <div className="minus-btn">
    //                 <button
    //                   className="btn btn-remv col-2 "
    //                   onClick={removeItemFromCart}
    //                 >
    //                   <span className="btn-icon">-</span>
    //                 </button>
    //               </div>
    //               {isItemInCart && (
    //                 <div className="col-3 text-center">
    //                   {isItemInCart.quantity}
    //                 </div>
    //               )}
    //               <div className="plus-btn">
    //                 <button
    //                   disabled={stockLimitExceeded}
    //                   className="col btn btn-add  "
    //                   onClick={addItemToCart}
    //                 >
    //                   <span className="btn-icon">+</span>
    //                 </button>
    //               </div>
    //             </div>
    //           ) : (
    //             <button
    //               className={`btn   px-2 my-1 ${isStockAvailable ? "btn-add-cart" : "btn-dark"}`}
    //               onClick={addItemToCart}
    //               disabled={!isStockAvailable}
    //             >
    //               {isStockAvailable ? "Add Cart" : "Out Of Stock"}
    //             </button>
    //           )}
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    //   <hr />
    // </div>
    <div className="menu-card-container mt-3">
      <div className="menu-card d-flex justify-content-between align-items-start p-3">

        {/* LEFT CONTENT */}
        <div className="menu-left-section">

          {/* Title */}
          <h4 className="menu-item-name mb-2">
            {menuItem.name}
          </h4>

        </div>

        {/* RIGHT SECTION (Price + Add Button) */}
        <div className="menu-right-section text-end">
          {menuItem.price > 0 && (
            <div className="menu-price mb-2">
              AED {(Math.round(menuItem.price * 100) / 100).toFixed(2)}
            </div>
          )}

          {isItemInCart ? (
            <div className="d-flex align-items-center justify-content-end gap-2">
              <button className="btn btn-remv" onClick={removeItemFromCart}>
                -
              </button>

              <span>{isItemInCart.quantity}</span>

              <button
                disabled={stockLimitExceeded}
                className="btn btn-add"
                onClick={addItemToCart}
              >
                +
              </button>
            </div>
          ) : (
            <button
              className={`btn ${isStockAvailable ? "btn-add-cart" : "btn-dark"}`}
              onClick={addItemToCart}
              disabled={!isStockAvailable}
            >
              {isStockAvailable ? "Add" : "Out Of Stock"}
            </button>
          )}
        </div>
      </div>
      {/* Description */}
      <div className="menu-left-section">
        <div
          className="menu-item-description mb-2 text-wrap"
          dangerouslySetInnerHTML={{ __html: menuItem.description || "" }}
        />
        {/* Image */}
        {menuItem.imageUrl && (
          <div className=" mt-3 mt-md-0 col-12 col-sm-7 col-md-5 col-lg-8">
            <div className="img-container">
              <img
                src={API_ROUTE + menuItem.imageUrl}
                className="img-fluid menu-item-img"
                alt={menuItem.name}
              />
            </div>
          </div>
        )}

        <hr />
      </div>
    </div>
  );
};

export default FoodItem;